module.exports = "/assets/6d67c47ae0e2c94c5e1cd1c20f3d8771.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/JT.png
// module id = 2646
// module chunks = 0